/**
 * The ten factors from the printed CHED Caraga activity evaluation form.
 *
 * `venueOnly` marks the items that only make sense when participants were
 * physically present. A virtual activity serves no food and books no venue, so
 * asking about them would force the respondent to invent a rating.
 */
export const EVALUATION_FACTORS = [
  { id: "objectives", label: "Attainment of the activity objectives/purposes" },
  { id: "schedule", label: "Schedule/Duration of the activity" },
  { id: "discussion_quality", label: "Quality of discussion of the topics/issues" },
  { id: "facilitation_quality", label: "Quality of facilitation of the activity" },
  { id: "participant_engagement", label: "Quality of participants' engagement in the activity" },
  { id: "resource_speakers", label: "Effectiveness of Resource Speakers in delivering the topics" },
  { id: "topic_significance", label: "Significance of the topics discussed" },
  { id: "organizer_facilitation", label: "Overall facilitation of the organizer" },
  { id: "food", label: "Food", venueOnly: true },
  { id: "venue", label: "Venue", venueOnly: true },
];

export const MODALITIES = [
  { id: "virtual", label: "Virtual", icon: "bi-camera-video-fill" },
  { id: "on-venue", label: "On Venue", icon: "bi-geo-alt-fill" },
];

export const RATING_SCALE = [
  { value: 1, label: "Poor" },
  { value: 2, label: "Fair" },
  { value: 3, label: "Good" },
  { value: 4, label: "Very Good" },
  { value: 5, label: "Excellent" },
];

/** Factors a respondent is asked to rate for the given modality. */
export function factorsFor(modality) {
  return EVALUATION_FACTORS.filter(
    (factor) => !factor.venueOnly || modality === "on-venue"
  );
}

/**
 * Ratings limited to the factors the modality actually shows.
 *
 * Switching from On Venue back to Virtual hides Food and Venue; without this
 * the answers given while they were visible would still ride along in the
 * payload, recording a food rating for an activity that served none.
 */
export function ratingsFor(modality, ratings) {
  return factorsFor(modality).reduce((kept, factor) => {
    if (ratings[factor.id] != null) kept[factor.id] = ratings[factor.id];
    return kept;
  }, {});
}
